import { Injectable } from '@angular/core';

/* Naming NOTE
  The API's file field is `fileItem` thus, we name it the same below
  it's like saying <input type='file' name='fileItem' />
  on a standard file field
*/

@Injectable()
export class FileUploadService {

    constructor(){ }

    fileUpload(fileItem:File, extraData?:object):any{

        const formData: FormData = new FormData();

        formData.append('fileItem', fileItem, fileItem.name);

        if (extraData) {

            for(let key in extraData){
                formData.append(key, extraData[key])
            }
        }

        return formData;
    }

    filesUpload(files: Array<File>, extraData?:object):any{

        const formData: FormData = new FormData();
        let i=1;
        for(let fileItem of files){
            formData.append('fileItem'+i, fileItem, fileItem.name);
            i++;
            }
            if (extraData) {
            for(let key in extraData){
                formData.append(key, extraData[key])
            }
        }
        return formData;
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/tools/elements/services/file-upload.service.ts